import React, { useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import { setCurrency } from '../actions/currency'
import { CURRENCIES, FEATURED, symbolFor } from '../utils/currency'

/**
 * Selector de divisa de la barra superior (junto al selector de idioma).
 * Mismo "pill" que GoogleTranslate/DarkModeToggle: el símbolo hace de thumb.
 * Solo cambia cómo se MUESTRAN los importes (símbolo), no los convierte.
 * Estilos en AppShell.jsx (bloque CURRENCY SELECTOR).
 */
function CurrencySelector({ code, defaultCode, setCurrency }) {
  const [query, setQuery] = useState('')
  const sym = symbolFor(code)

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase()
    if (!q) return CURRENCIES
    return CURRENCIES.filter(
      (c) => c.code.toLowerCase().includes(q) || c.name.toLowerCase().includes(q) || c.symbol.toLowerCase().includes(q)
    )
  }, [query])

  const featured = filtered.filter((c) => FEATURED.includes(c.code))
  const others = filtered.filter((c) => !FEATURED.includes(c.code))

  const renderItem = (c) => (
    <DropdownItem
      key={c.code}
      onClick={() => setCurrency(c.code)}
      className={`cur-item notranslate${c.code === code ? ' cur-item--active' : ''}`}
      translate="no"
    >
      <span className="cur-item-symbol">{c.symbol}</span>
      <span className="cur-item-code">{c.code}</span>
      <span className="cur-item-name">{c.name}</span>
      {c.code === defaultCode && <span className="cur-item-default" title="Divisa por defecto de tu cuenta">★</span>}
    </DropdownItem>
  )

  return (
    <UncontrolledDropdown nav inNavbar className="cur-dropdown notranslate" translate="no">
      <DropdownToggle nav caret className="cur-toggle" title="Moneda" aria-label="Seleccionar moneda">
        <span className="cur-thumb" style={{ fontSize: sym.length > 2 ? 8 : sym.length > 1 ? 10 : 12 }}>{sym}</span>
        <span className="cur-code">{code}</span>
      </DropdownToggle>
      <DropdownMenu right className="cur-menu">
        <div className="cur-search" onClick={(e) => e.stopPropagation()}>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Buscar divisa..."
            aria-label="Buscar divisa"
            autoComplete="off"
          />
        </div>
        <div className="cur-list">
          {featured.map(renderItem)}
          {featured.length > 0 && others.length > 0 && <DropdownItem divider />}
          {others.map(renderItem)}
          {filtered.length === 0 && <div className="cur-empty">Sin resultados</div>}
        </div>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

const mapStateToProps = (state) => ({
  code: state.currency.code,
  defaultCode: state.currency.defaultCode,
})

const mapDispatchToProps = (dispatch) => ({
  setCurrency: bindActionCreators(setCurrency, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(CurrencySelector)
